import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';
import { setNavSate } from '@/utils/navHelper';

import Base from '../components/layout/Base';
import Index from '../pages/home/Index';
import Error from '../pages/Error';
import passport from './passport';
import fakeDataStatistics from './fakeDataStatistics'; // 成都课后服务 静态

Vue.use(Router);

// webpack导入各个模块的路由
const requireRouteFilePaths = require.context('./', true, /^.\/.*\/.*\.js$/);
const otherRoutes = requireRouteFilePaths
  .keys()
  .filter((item) => !item.includes('passport') && !item.includes('fakeDataStatistics'))
  .map((routeFilePath) => requireRouteFilePaths(routeFilePath)['default'])
  .reduce((prev, next) => prev.concat(next));
// console.log(requireRouteFilePaths.keys())
// console.log(otherRoutes)

const router = new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'root',
      redirect: { name: 'index' }
    },
    {
      path: '/index',
      name: 'index',
      component: Index,
      meta: { title: '管理系统-首页' }
    },
    {
      path: '/base',
      name: 'base',
      component: Base,
      children: otherRoutes
    },
    ...passport,
    ...fakeDataStatistics,
    {
      path: '*',
      name: '404',
      component: Error,
      meta: { title: '404' }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

// 不需登录的页面
const freeRoutes = ['passport_login', 'passport_document'];

// 服务 静态页面，不需要登录
const fakeDataRoutes = ['dataStatistics_index', 'dataStatistics_dataStatistics'];

// 全局前置导航守卫
router.beforeEach(async(to, from, next) => {
  // 服务 静态页面，不需要登录
  if (fakeDataRoutes.some((item) => to.name === item)) {
    document.title = to.meta.title;
    next();
    return;
  }

  store.commit('SET_CURRENTROUTEINFO', to);
  store.commit('SET_BROWSINGHISTORYLIST', to);
  const title = to.meta.title;
  const toName = to.name;
  const htmall_is_login = localStorage.getItem('htmall_is_login');
  // keepAliveCacheDestroy(toName)
  console.log(htmall_is_login, toName, 'htmall_is_login', to);
  // controlRouteCache(to, from);
  const portOrg = Number(localStorage.getItem('portOrg'));
  let portOrgTitle = '';
  if (portOrg === 0) {
    portOrgTitle = '宏兔兔课后托管管理平台运营端';
  } else if (portOrg === 1) {
    portOrgTitle = '宏兔兔课后托管管理平台教育局端';
  } else if (portOrg === 2) {
    portOrgTitle = '宏兔兔课后托管管理平台学校端';
  } else if (portOrg === 3) {
    portOrgTitle = '宏兔兔课后托管管理平台服务端';
  } else if (portOrg === 4) {
    portOrgTitle = '宏兔兔课后托管管理平台餐饮服务端';
  } else {
    portOrgTitle = '宏兔兔课后托管';
  }
  if (store.state.isMaoming) {
    portOrgTitle = '选课报名服务管理系统';
  }
  if (title) {
    document.title = store.state.isMaoming ? title : `${portOrgTitle}-${title}`;
  }
  if (htmall_is_login == 1) {
    if (toName == 'passport_login') {
      next({ path: '/index' });
    }
  }
  if (freeRoutes.some((item) => to.name === item)) {
    next();
  } else {
    if (htmall_is_login == 1) {
      if (portOrg === 0) {
        // 获取学校信息列表
        // await store.dispatch('getSchoolList')
        store.dispatch('getSchoolList');
      }
      store.commit('SET_CURRENTROUTEINFO', to);
      setNavSate(to);
      next();
    } else {
      next({ name: 'passport_login' });
      document.title = `${portOrgTitle}`;
    }
  }
});

export default router;
